var _circle, _circle2, _path, _path2, _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3, _path4, _line, _rect8, _path5, _path6, _line2, _path7, _path8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path9, _g2, _path0, _g3, _path1, _g4, _rect13, _rect14, _line3, _circle3, _circle4, _path10, _path11, _rect15, _rect16, _rect17, _path12, _path13, _rect18, _rect19, _rect20, _rect21, _line4, _line5, _line6, _rect22, _rect23, _path14, _rect24, _circle5, _circle6, _circle7, _rect25, _rect26, _line7, _path15, _rect27, _line8, _path16, _rect28, _line9, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 250,
    viewBox: "0 0 470 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 171,
    cy: 133,
    r: 115,
    fill: "#F3E4F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 359,
    cy: 85,
    r: 56,
    fill: "#F3E4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 234H361C361 242.837 353.837 250 345 250H113C104.163 250 97 242.837 97 234Z",
    fill: "#8C8CAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119 115C119 112.239 121.239 110 124 110H331C333.761 110 336 112.239 336 115V229H119V115Z",
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 115,
    width: 208,
    height: 119,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.657 148.207C303.329 148.207 303.329 143.29 321 143.29V178H-916V174.728C-896.856 174.728 -898.328 176.537 -880.657 176.537C-862.986 176.537 -862.986 171.4 -845.314 171.4C-827.643 171.4 -830.588 172.981 -809.971 172.981C-789.355 172.981 -795.245 175.94 -774.629 175.94C-754.012 175.94 -758.43 174.816 -739.286 174.816C-720.142 174.816 -723.823 169.459 -703.943 169.459C-684.062 169.459 -689.217 171.207 -668.6 171.207C-647.983 171.207 -651.665 173.613 -633.257 173.613C-614.849 173.613 -617.795 165.622 -597.914 165.622C-578.034 165.622 -580.243 168.388 -562.571 168.388C-544.9 168.388 -547.845 164.515 -527.229 164.515C-506.612 164.515 -511.03 166.992 -491.886 166.992C-472.742 166.992 -475.687 156.866 -456.543 156.866C-437.399 156.866 -441.08 159.685 -421.2 159.685C-401.32 159.685 -406.474 161.547 -385.857 161.547C-365.241 161.547 -370.395 156.717 -350.514 156.717C-330.634 156.717 -335.788 159.088 -315.171 159.088C-294.555 159.088 -298.236 155.18 -279.829 155.18C-261.421 155.18 -263.63 148.647 -244.486 148.647C-225.342 148.647 -228.287 159.58 -209.143 159.58C-189.999 159.58 -192.208 151.922 -173.8 151.922C-155.392 151.922 -159.074 155.277 -138.457 155.277C-117.84 155.277 -122.258 158.289 -103.114 158.289C-83.9702 158.289 -86.1792 153.301 -67.7714 153.301C-49.3637 153.301 -50.8363 158.043 -32.4286 158.043C-14.0208 158.043 -16.2298 155.935 2.91428 155.935C22.0583 155.935 19.1131 151.588 38.2571 151.588C57.4012 151.588 54.456 153.327 73.6 153.327C92.744 153.327 91.2714 146.978 108.943 146.978C126.614 146.978 123.669 155.681 144.286 155.681C164.902 155.681 159.748 149.771 179.629 149.771C199.509 149.771 196.564 152.203 214.971 152.203C233.379 152.203 231.907 146.144 250.314 146.144C268.722 146.144 267.986 148.207 285.657 148.207Z",
    fill: "#F3E4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321 143.29C303.329 143.29 303.329 148.222 285.657 148.222C267.986 148.222 268.722 146.152 250.314 146.152C231.907 146.152 233.379 152.229 214.971 152.229C196.564 152.229 199.509 149.79 179.629 149.79C159.748 149.79 164.902 155.717 144.286 155.717C123.669 155.717 126.614 146.989 108.943 146.989C91.2714 146.989 92.744 153.357 73.6 153.357C54.456 153.357 57.4012 151.613 38.2571 151.613C19.1131 151.613 22.0583 155.972 2.91428 155.972C-16.2298 155.972 -14.0208 158.086 -32.4286 158.086C-50.8363 158.086 -49.3637 153.33 -67.7714 153.33C-86.1792 153.33 -83.9702 158.333 -103.114 158.333C-122.258 158.333 -117.84 155.312 -138.457 155.312C-159.074 155.312 -155.392 151.947 -173.8 151.947C-192.208 151.947 -189.999 159.627 -209.143 159.627C-228.287 159.627 -225.342 148.662 -244.486 148.662C-263.63 148.662 -261.421 155.215 -279.829 155.215C-298.236 155.215 -294.555 159.134 -315.171 159.134C-335.788 159.134 -330.634 156.756 -350.514 156.756C-370.395 156.756 -365.24 161.6 -385.857 161.6C-406.474 161.6 -401.32 159.733 -421.2 159.733C-441.08 159.733 -437.399 156.906 -456.543 156.906C-475.687 156.906 -472.742 167.061 -491.886 167.061C-511.03 167.061 -506.612 164.577 -527.229 164.577C-547.845 164.577 -544.9 168.461 -562.571 168.461C-580.243 168.461 -578.034 165.687 -597.914 165.687C-617.795 165.687 -614.849 173.702 -633.257 173.702C-651.665 173.702 -647.983 171.288 -668.6 171.288C-689.217 171.288 -684.063 169.536 -703.943 169.536C-723.823 169.536 -720.142 174.908 -739.286 174.908C-758.43 174.908 -754.012 176.036 -774.629 176.036C-795.245 176.036 -789.355 173.068 -809.971 173.068C-830.588 173.068 -827.643 171.482 -845.314 171.482C-862.986 171.482 -862.986 176.635 -880.657 176.635C-898.329 176.635 -896.856 174.82 -916 174.82",
    stroke: "#A4A4B3",
    strokeWidth: 0.665765
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 289.307 145.332)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 250.307 143.187)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 324.307 140.262)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 220.307 149.037)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 183.307 146.697)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 187,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#665891"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162 203H178C178 198.594 176.194 194.321 173.34 191.66L162 203Z",
    fill: "#F3E4F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162 203V187C166.406 187 170.601 188.573 173.34 191.66L162 203Z",
    fill: "#E9E8FC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 141,
    y1: 129.5,
    x2: 331,
    y2: 129.5,
    stroke: "#E7E5E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 187,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#665891"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215 203H199C199 207.406 200.823 211.395 203.718 214.282L215 203Z",
    fill: "#E9E8FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215 203H199C199 198.594 200.823 194.605 203.718 191.718L215 203Z",
    fill: "#E9E8FC"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 141.5,
    y1: 130,
    x2: 141.5,
    y2: 234,
    stroke: "#E7E5E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.997 120.431C131.575 120.431 130.701 120.431 130.555 120.431H130.476V120.603C130.482 121.431 130.651 122.109 131.152 122.701C131.738 123.385 132.583 123.586 133.332 123.994C133.597 124.138 133.901 124.328 133.901 124.678C133.901 125.126 133.563 125.402 132.882 125.402C132.273 125.402 131.603 125.08 131.073 124.626L130.132 125.782C130.87 126.494 131.884 126.856 132.837 126.856C134.589 126.856 135.597 125.782 135.597 124.546C135.597 124.247 135.552 123.943 135.434 123.667C135.276 123.293 135 123 134.668 122.787C134.662 122.782 134.651 122.776 134.645 122.77C134.284 122.534 133.901 122.402 133.507 122.253C133.417 122.218 133.332 122.184 133.242 122.149C132.651 121.908 132.144 121.552 132.02 120.885C132.02 120.874 131.997 120.707 131.997 120.598V120.431Z",
    fill: "#1F1D30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.876 120.161C132.876 120.885 133.451 121.471 134.16 121.471C134.87 121.471 135.445 120.885 135.445 120.161C135.445 119.437 134.87 118.851 134.16 118.851C133.451 118.851 132.876 119.437 132.876 120.161Z",
    fill: "#D092DD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 189,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#D2D2D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 191,
    width: 35,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 195,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 210,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#D2D2D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 212,
    width: 35,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 216,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.827 25H274.984C272.238 25 270.01 27.2282 270 29.9738V49.7594C270 52.5049 272.228 54.7332 274.974 54.7431H283.061L288.055 62.552C288.234 62.8404 288.552 63.0095 288.89 62.9996C289.229 62.9996 289.547 62.8305 289.726 62.542L294.67 54.7431H302.827C305.572 54.7332 307.801 52.5049 307.801 49.7594V29.9738C307.791 27.2282 305.572 25 302.827 25ZM305.811 49.7594C305.811 51.4107 304.468 52.7536 302.827 52.7536H294.143C293.804 52.7536 293.486 52.9227 293.297 53.2112L288.9 60.1546L284.454 53.2112C284.275 52.9227 283.956 52.7536 283.618 52.7536H274.974C273.322 52.7437 271.99 51.4107 271.99 49.7594V29.9738C271.99 28.3225 273.332 26.9895 274.974 26.9895H302.817C304.468 26.9895 305.801 28.3225 305.811 29.9738V49.7594Z",
    fill: "#4A4A68"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.75 39.5C295.75 44.75 289 49.25 289 49.25C289 49.25 282.25 44.75 282.25 39.5C282.25 37.7098 282.961 35.9929 284.227 34.727C285.493 33.4612 287.21 32.75 289 32.75C290.79 32.75 292.507 33.4612 293.773 34.727C295.039 35.9929 295.75 37.7098 295.75 39.5Z",
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 41.75C290.243 41.75 291.25 40.7426 291.25 39.5C291.25 38.2574 290.243 37.25 289 37.25C287.757 37.25 286.75 38.2574 286.75 39.5C286.75 40.7426 287.757 41.75 289 41.75Z",
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.827 54H75.9837C73.2382 54 71.0099 56.2282 71 58.9738V78.7594C71 81.5049 73.2282 83.7332 75.9738 83.7431H84.0611L89.0548 91.552C89.2338 91.8404 89.5522 92.0095 89.8904 91.9996C90.2286 91.9996 90.5469 91.8305 90.726 91.542L95.6699 83.7431H103.827C106.572 83.7332 108.801 81.5049 108.801 78.7594V58.9738C108.791 56.2282 106.572 54 103.827 54ZM106.811 78.7594C106.811 80.4107 105.468 81.7536 103.827 81.7536H95.1427C94.8045 81.7536 94.4861 81.9227 94.2971 82.2112L89.9003 89.1546L85.4538 82.2112C85.2747 81.9227 84.9564 81.7536 84.6182 81.7536H75.9738C74.3225 81.7437 72.9895 80.4107 72.9895 78.7594V58.9738C72.9895 57.3225 74.3324 55.9895 75.9738 55.9895H103.817C105.468 55.9895 106.801 57.3225 106.811 58.9738V78.7594Z",
    fill: "#4A4A68"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.2362 68.1651C92.31 68.2938 92.4203 68.3977 92.5531 68.4637C92.6859 68.5297 92.8354 68.5549 92.9825 68.536C93.1296 68.517 93.2678 68.4549 93.3797 68.3575C93.4915 68.26 93.5719 68.1315 93.6107 67.9884C93.6495 67.8452 93.645 67.6938 93.5978 67.5531C93.5505 67.4125 93.4626 67.2891 93.3452 67.1984C93.2278 67.1078 93.0862 67.054 92.9382 67.0438C92.7902 67.0337 92.6425 67.0677 92.5138 67.1414C92.3413 67.2404 92.2151 67.4038 92.163 67.5958C92.1109 67.7878 92.1373 67.9926 92.2362 68.1651ZM96.3372 65.2001L91.2188 63.812C91.1234 63.7866 91.0239 63.7802 90.9261 63.7933C90.8283 63.8064 90.734 63.8386 90.6486 63.8882L83.4915 67.9916C82.9738 68.2884 82.5952 68.7787 82.439 69.3547C82.2829 69.9306 82.3619 70.545 82.6587 71.0627L84.8969 74.9666C85.1937 75.4842 85.684 75.8628 86.2599 76.019C86.8359 76.1752 87.4503 76.0962 87.968 75.7994L95.1251 71.696C95.211 71.6474 95.2865 71.5823 95.3472 71.5045C95.4079 71.4266 95.4526 71.3376 95.4789 71.2424L96.8669 66.124C96.8932 66.0285 96.9004 65.9288 96.8879 65.8306C96.8755 65.7324 96.8438 65.6376 96.7945 65.5517C96.7453 65.4658 96.6795 65.3905 96.601 65.3302C96.5225 65.2698 96.4329 65.2256 96.3372 65.2001ZM94.1122 70.5476L87.2219 74.4981C87.0493 74.597 86.8445 74.6234 86.6525 74.5713C86.4606 74.5192 86.2971 74.393 86.1982 74.2205L83.96 70.3166C83.861 70.144 83.8347 69.9392 83.8868 69.7473C83.9388 69.5553 84.065 69.3918 84.2376 69.2929L91.1279 65.3424L95.2227 66.4529L94.1122 70.5476Z",
    fill: "#4A4A68"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M409.827 185H381.984C379.238 185 377.01 187.228 377 189.974V209.759C377 212.505 379.228 214.733 381.974 214.743H390.061L395.055 222.552C395.234 222.84 395.552 223.01 395.89 223C396.229 223 396.547 222.83 396.726 222.542L401.67 214.743H409.827C412.572 214.733 414.801 212.505 414.801 209.759V189.974C414.791 187.228 412.572 185 409.827 185ZM412.811 209.759C412.811 211.411 411.468 212.754 409.827 212.754H401.143C400.804 212.754 400.486 212.923 400.297 213.211L395.9 220.155L391.454 213.211C391.275 212.923 390.956 212.754 390.618 212.754H381.974C380.322 212.744 378.99 211.411 378.99 209.759V189.974C378.99 188.322 380.332 186.99 381.974 186.99H409.817C411.468 186.99 412.801 188.322 412.811 189.974V209.759Z",
    fill: "#4A4A68"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396 202.25C397.243 202.25 398.25 201.243 398.25 200C398.25 198.757 397.243 197.75 396 197.75C394.757 197.75 393.75 198.757 393.75 200C393.75 201.243 394.757 202.25 396 202.25Z",
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.55 202.25C401.45 202.476 401.42 202.727 401.464 202.97C401.509 203.214 401.625 203.438 401.797 203.615L401.843 203.66C401.982 203.799 402.093 203.965 402.168 204.147C402.244 204.329 402.282 204.524 402.282 204.721C402.282 204.918 402.244 205.114 402.168 205.296C402.093 205.478 401.982 205.643 401.843 205.782C401.703 205.922 401.538 206.033 401.356 206.108C401.174 206.184 400.978 206.222 400.781 206.222C400.584 206.222 400.389 206.184 400.207 206.108C400.025 206.033 399.859 205.922 399.72 205.782L399.675 205.737C399.498 205.565 399.274 205.449 399.03 205.404C398.787 205.36 398.536 205.39 398.31 205.49C398.088 205.585 397.899 205.743 397.766 205.944C397.632 206.145 397.561 206.381 397.56 206.622V206.75C397.56 207.148 397.402 207.529 397.121 207.811C396.839 208.092 396.458 208.25 396.06 208.25C395.662 208.25 395.281 208.092 394.999 207.811C394.718 207.529 394.56 207.148 394.56 206.75V206.682C394.554 206.434 394.474 206.193 394.329 205.992C394.185 205.79 393.983 205.636 393.75 205.55C393.524 205.45 393.273 205.42 393.03 205.464C392.786 205.509 392.562 205.625 392.385 205.797L392.34 205.843C392.201 205.982 392.035 206.093 391.853 206.168C391.671 206.244 391.476 206.282 391.279 206.282C391.082 206.282 390.886 206.244 390.704 206.168C390.522 206.093 390.357 205.982 390.217 205.843C390.078 205.703 389.967 205.538 389.892 205.356C389.816 205.174 389.778 204.978 389.778 204.781C389.778 204.584 389.816 204.389 389.892 204.207C389.967 204.025 390.078 203.859 390.217 203.72L390.262 203.675C390.435 203.498 390.551 203.274 390.596 203.03C390.64 202.787 390.61 202.536 390.51 202.31C390.415 202.088 390.257 201.899 390.056 201.766C389.855 201.632 389.619 201.561 389.378 201.56H389.25C388.852 201.56 388.471 201.402 388.189 201.121C387.908 200.839 387.75 200.458 387.75 200.06C387.75 199.662 387.908 199.281 388.189 198.999C388.471 198.718 388.852 198.56 389.25 198.56H389.317C389.566 198.554 389.807 198.474 390.008 198.329C390.21 198.185 390.364 197.983 390.45 197.75C390.55 197.524 390.58 197.273 390.536 197.03C390.491 196.786 390.375 196.562 390.202 196.385L390.158 196.34C390.018 196.201 389.907 196.035 389.832 195.853C389.756 195.671 389.718 195.476 389.718 195.279C389.718 195.082 389.756 194.886 389.832 194.704C389.907 194.522 390.018 194.357 390.158 194.217C390.297 194.078 390.462 193.967 390.644 193.892C390.826 193.816 391.022 193.778 391.219 193.778C391.416 193.778 391.611 193.816 391.793 193.892C391.975 193.967 392.141 194.078 392.28 194.217L392.325 194.262C392.502 194.435 392.726 194.551 392.97 194.596C393.213 194.64 393.464 194.61 393.69 194.51H393.75C393.972 194.415 394.161 194.257 394.294 194.056C394.428 193.855 394.499 193.619 394.5 193.378V193.25C394.5 192.852 394.658 192.471 394.939 192.189C395.221 191.908 395.602 191.75 396 191.75C396.398 191.75 396.779 191.908 397.061 192.189C397.342 192.471 397.5 192.852 397.5 193.25V193.317C397.501 193.559 397.572 193.795 397.706 193.996C397.839 194.197 398.028 194.355 398.25 194.45C398.476 194.55 398.727 194.58 398.97 194.536C399.214 194.491 399.438 194.375 399.615 194.202L399.66 194.158C399.799 194.018 399.965 193.907 400.147 193.832C400.329 193.756 400.524 193.718 400.721 193.718C400.918 193.718 401.114 193.756 401.296 193.832C401.478 193.907 401.643 194.018 401.782 194.158C401.922 194.297 402.033 194.462 402.108 194.644C402.184 194.826 402.222 195.022 402.222 195.219C402.222 195.416 402.184 195.611 402.108 195.793C402.033 195.975 401.922 196.141 401.782 196.28L401.737 196.325C401.565 196.502 401.449 196.726 401.404 196.97C401.36 197.213 401.39 197.464 401.49 197.69V197.75C401.585 197.972 401.743 198.161 401.944 198.294C402.145 198.428 402.381 198.499 402.622 198.5H402.75C403.148 198.5 403.529 198.658 403.811 198.939C404.092 199.221 404.25 199.602 404.25 200C404.25 200.398 404.092 200.779 403.811 201.061C403.529 201.342 403.148 201.5 402.75 201.5H402.682C402.441 201.501 402.205 201.572 402.004 201.706C401.803 201.839 401.645 202.028 401.55 202.25V202.25Z",
    stroke: "#4A4A68",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 12.988,
    y: 102.108,
    width: 85.012,
    height: 116.892,
    rx: 4,
    fill: "#D092DD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 97.2048,
    width: 83.012,
    height: 114.892,
    rx: 3,
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.36133,
    y1: 109.374,
    x2: 82.6505,
    y2: 109.374,
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.26501,
    cy: 103.289,
    r: 2.36145,
    fill: "#77778E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.3495,
    cy: 103.289,
    r: 2.36145,
    fill: "#D2D2D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3995 125.847C38.3394 125.847 36.1484 125.847 35.7809 125.847H35.583V126.275C35.5971 128.327 36.0212 130.008 37.2792 131.476C38.7493 133.172 40.8696 133.67 42.7496 134.682C43.414 135.038 44.1773 135.509 44.1773 136.378C44.1773 137.489 43.3292 138.173 41.6188 138.173C40.0922 138.173 38.41 137.375 37.0813 136.25L34.7207 139.114C36.5724 140.881 39.1168 141.779 41.5057 141.779C45.9018 141.779 48.4321 139.114 48.4321 136.05C48.4321 135.309 48.319 134.554 48.0221 133.87C47.6263 132.944 46.9337 132.217 46.0997 131.69C46.0856 131.675 46.0573 131.661 46.0432 131.647C45.1385 131.063 44.1773 130.735 43.1878 130.364C42.9616 130.279 42.7496 130.193 42.5235 130.108C41.0392 129.509 39.767 128.626 39.4561 126.973C39.4561 126.944 39.3995 126.531 39.3995 126.26V125.847Z",
    fill: "#1F1D30"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6047 125.177C41.6047 126.973 43.0465 128.426 44.8276 128.426C46.6087 128.426 48.0505 126.973 48.0505 125.177C48.0505 123.382 46.6087 121.928 44.8276 121.928C43.0465 121.928 41.6047 123.382 41.6047 125.177Z",
    fill: "#D092DD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 13.488,
    y: 152.199,
    width: 58.0361,
    height: 9.62651,
    rx: 1.5,
    fill: "white",
    stroke: "#4A4A68"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 13.488,
    y: 167.548,
    width: 58.0361,
    height: 9.62651,
    rx: 1.5,
    fill: "white",
    stroke: "#4A4A68"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6145,
    y: 185.94,
    width: 37.7831,
    height: 10.6265,
    rx: 2,
    fill: "#D092DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M215.097 8.44827H151.655C150.551 8.44827 149.655 9.3437 149.655 10.4483V71C149.655 72.1046 150.551 73 151.655 73H256.897C258.001 73 258.897 72.1046 258.897 71V27.8276C258.897 26.723 258.001 25.8276 256.897 25.8276H230.696C230.083 25.8276 229.503 25.5458 229.124 25.0632L216.67 9.21263C216.29 8.73005 215.711 8.44827 215.097 8.44827Z",
    fill: "#D092DD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.442 1H138C136.895 1 136 1.89543 136 3V63.5517C136 64.6563 136.895 65.5517 138 65.5517H243.241C244.346 65.5517 245.241 64.6563 245.241 63.5517V20.3793C245.241 19.2747 244.346 18.3793 243.241 18.3793H217.041C216.427 18.3793 215.848 18.0975 215.468 17.615L203.014 1.76436C202.635 1.28178 202.055 1 201.442 1Z",
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 142.207,
    y: 5.96552,
    width: 18.6207,
    height: 2.48276,
    rx: 1.24138,
    fill: "#4A4A68"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 203.034,
    y: 51.8965,
    width: 37.2414,
    height: 7.44828,
    rx: 2,
    fill: "#D092DD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 142.207,
    y: 24.5862,
    width: 7.44828,
    height: 7.44828,
    rx: 2,
    fill: "#D2D2D9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 142.207,
    y: 38.2414,
    width: 7.44828,
    height: 7.44828,
    rx: 2,
    fill: "#D2D2D9"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 142.207,
    y1: 35.2586,
    x2: 240.276,
    y2: 35.2586,
    stroke: "#F3F2F4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 142.207,
    y1: 48.9138,
    x2: 240.276,
    y2: 48.9138,
    stroke: "#F3F2F4"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 142.207,
    y1: 35.2586,
    x2: 240.276,
    y2: 35.2586,
    stroke: "#F3F2F4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 377.018,
    y: 49.0089,
    width: 92.2832,
    height: 124.991,
    rx: 4,
    fill: "#D092DD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 43,
    width: 90.2832,
    height: 122.991,
    rx: 3,
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M372.345 55.4336H445.938",
    stroke: "#8C8CA1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 364.168,
    y: 64.1947,
    width: 89.9469,
    height: 23.3628,
    fill: "#4A4A68"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.345,
    cy: 54.177,
    r: 4,
    fill: "#4A4A68"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.726,
    cy: 54.177,
    r: 4,
    fill: "#D092DD"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 443.106,
    cy: 54.177,
    r: 3.5,
    fill: "white",
    stroke: "#4A4A68"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 421.407,
    y: 72.3717,
    width: 29.2035,
    height: 8.17699,
    rx: 2,
    fill: "#D092DD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 419.071,
    y: 150.637,
    width: 29.2035,
    height: 8.17699,
    rx: 2,
    fill: "#4A4A68"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 370.009,
    y1: 102.243,
    x2: 448.274,
    y2: 102.243,
    stroke: "#D2D2D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M370.009 102.159H386.947",
    stroke: "#4A4A68"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 371.677,
    y: 113.757,
    width: 11.8496,
    height: 11.8496,
    rx: 1.5,
    fill: "white",
    stroke: "#4A4A68"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 389.867,
    y1: 116.261,
    x2: 442.434,
    y2: 116.261,
    stroke: "#4A4A68"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M389.867 122.018H425.496",
    stroke: "#4A4A68"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 371.677,
    y: 132.447,
    width: 11.8496,
    height: 11.8496,
    rx: 1.5,
    fill: "white",
    stroke: "#4A4A68"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 389.867,
    y1: 134.951,
    x2: 442.434,
    y2: 134.951,
    stroke: "#4A4A68"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M389.867 140.708H425.496",
    stroke: "#4A4A68"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 34.7344,
    fill: "white",
    transform: "matrix(-1 0 0 1 321 143.266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(280 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(78 65.9529) rotate(-29.8271)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(387 191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReDesign);
export default __webpack_public_path__ + "static/media/re-design.b9eb2477b1687ba90a02a63f35a9e32f.svg";
export { ForwardRef as ReactComponent };